import { registerPlugin } from '@capacitor/core';

const BackgroundService = registerPlugin('BackgroundService');

export default BackgroundService;
